import {Dispatch, SetStateAction, useEffect, useRef, useState} from "react";
import {IOperationResponse} from "@localization/siteMap/siteMapInterfaces.ts";

/**
 * Retorna o valor de um tipo definido
 * Caso o valor seja um numero, utiliza do getter especificado pra pegar o valor
 * Caso o endpoint traga uma array, trás o primeiro item da array
 * Caso o valor seja um objeto, retorna o mesmo objeto considerando que o objeto é do tipo definido
 * @param props
 */
export function useValue<T>(props: {
	value: T | number,
	getter: () => Promise<IOperationResponse<T | T[]>>,
}): [T | undefined, Dispatch<SetStateAction<T>>, T | undefined] {
	const [value, setValue] = useState<T | undefined>()
	const [originalValue, setOriginalValue] = useState<T | undefined>()
	const valueRef = useRef<T | undefined>(value)

	useEffect(() => {
		if (valueRef.current == props.value) return;
		if (typeof props.value === 'number') {
			props.getter().then(x => {
				if (x.items != null) {
					if (Array.isArray(x.items)) {
						setValue((x.items as T[])[0])
						return
					}
					setValue(x.items)
					setOriginalValue({...x.items})
				}
			})
		} else {
			setValue(props.value)
			setOriginalValue({...props.value})

		}
	}, [props.value]);

	useEffect(() => {
		if (typeof value != 'number' && value != null && valueRef.current != value) {
			valueRef.current = value;
		}
	}, [value]);


	return [value, setValue as Dispatch<SetStateAction<T>>, originalValue]
}
